import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Publiseringskrav } from 'services/KjederegisteretAdminApi/EnhetApi/types';

interface Props {
  krav: Publiseringskrav[];
  children: React.ReactElement;
}

/**
 * Viser alle krav for publisering med status. Kravene kommer fra API-et, som eier reglene.
 * Triggeren ligger på en wrapper-span fordi en deaktivert knapp ikke sender mus-/fokus-hendelser.
 */
const PubliseringskravPopover = ({ krav, children }: Props) => {
  if (!krav || krav.length === 0) return children;

  const popover = (
    <Popover id="publiseringskrav-popover">
      <Popover.Header as="h4">Krav for publisering</Popover.Header>
      <Popover.Body>
        <ul className="list-unstyled mb-0">
          {krav.map((k) => (
            <li key={k.kode} className={k.oppfylt ? 'text-success' : 'text-danger'}>
              <span aria-hidden="true">{k.oppfylt ? '✓' : '✗'}</span>{' '}
              <span className="visually-hidden">{k.oppfylt ? 'Oppfylt: ' : 'Mangler: '}</span>
              {k.tekst.replace(/ for å bli publisert!$/, '')}
            </li>
          ))}
        </ul>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement="bottom" trigger={['hover', 'focus']} overlay={popover}>
      <span tabIndex={0} className="d-inline-block">
        {children}
      </span>
    </OverlayTrigger>
  );
};

export default PubliseringskravPopover;
